import wentWrongImage from '@assets/images/something-went-wrong.svg';
import erroImage from '@assets/images/profile-error-illustration.svg';

export enum PROFILE_ERROR {
  UNAUTHORIZED = 'UNAUTHORIZED',
  INVALID_LINK = 'INVALID_LINK',
  ALREADY_UNSUBSCRIBED = 'ALREADY_UNSUBSCRIBED',
  SERVER_ERROR = 'SERVER_ERROR',
  ACCESS_EXPIRED = 'ACCESS_EXPIRED',
  APPROVAL_PENDING = 'APPROVAL_PENDING',
  CONTENT_NOT_FOUND = 'CONTENT_NOT_FOUND',
  DOWNLOAD_ACCESS_REVOKED = 'DOWNLOAD_ACCESS_REVOKED',
  CONTENT_ACCESS_REVOKED = 'CONTENT_ACCESS_REVOKED',
  PROFILE_RELOAD = 'PROFILE_RELOAD'
}

export interface IErrorDetails {
  img: string;
  title: string;
  message: string;
}

export const ERROR_DETAILS_MAP: { [key: string]: IErrorDetails } = {
  UNAUTHORIZED: { img: erroImage, title: 'PROFILE_UNAVAILABLE_TITLE', message: 'PROFILE_UNAVAILABLE_MESSAGE' },
  INVALID_LINK: { img: erroImage, title: 'INVALID_LINK_TITLE', message: 'INVALID_LINK_INFO' },
  ALREADY_UNSUBSCRIBED: {
    img: erroImage,
    title: 'ALREADY_UNSUBSCRIBED_TITLE',
    message: 'ALREADY_UNSUBSCRIBED_MESSAGE'
  },
  VIEW_RESTRICTED: { img: erroImage, title: 'INVALID_LINK_TITLE', message: 'INVALID_LINK_INFO' },
  ACCESS_REVOKED: { img: erroImage, title: 'INVALID_LINK_TITLE', message: 'INVALID_LINK_INFO' },
  SERVER_ERROR: { img: wentWrongImage, title: 'SOMETHING_WENT_WRONG_TITLE', message: 'SOMETHING_WENT_WRONG_INFO' },
  ACCESS_EXPIRED: { img: erroImage, title: 'EXPIRED_LINK_TITLE', message: 'EXPIRED_LINK_INFO' },
  APPROVAL_PENDING: { img: erroImage, title: 'EXPIRED_LINK_TITLE', message: 'EXPIRED_LINK_INFO' }
};

export const WARNING_ERROR_LIST: string[] = [PROFILE_ERROR.CONTENT_NOT_FOUND, PROFILE_ERROR.CONTENT_ACCESS_REVOKED, PROFILE_ERROR.DOWNLOAD_ACCESS_REVOKED];
